import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import {
    Flex, Image, Text, Button
} from 'components/ui';
import { Container } from 'components/ui';
import RecServiceCarousel from 'components/RecServiceCarousel';
import ConstructorCarousel from 'components/ConstructorCarousel';

import localeUtils from 'utils/LanguageLocale';
import { CONSTRUCTOR_PODS, GROUPING } from 'constants/constructorConstants';

function ProfileError() {
    const getText = localeUtils.getLocaleResourceFile('components/CreatorStoreFront/CSFErrors/locales', 'ProfileError');
    const CarouselComponent = Sephora.configurationSettings.recsMigration?.isEnabled ? RecServiceCarousel : ConstructorCarousel;

    return (
        <Container
            id='csf_profile_error_wrapper'
            paddingTop={['40px', null, 6]}
            maxWidth={375}
        >
            <Flex
                flexDirection='column'
                alignItems='center'
                gap={5}
                marginBottom={7}
            >
                <Image
                    src='/img/ufe/store/list-loveless.svg'
                    display='block'
                    size={110}
                    disableLazyLoad={true}
                />
                <Text
                    is='p'
                    lineHeight='18px'
                    textAlign='center'
                >
                    {getText('errorDescriptionLine1')}
                    <br />
                    {getText('errorDescriptionLine2')}
                </Text>
                <Button
                    variant='primary'
                    href='/'
                    children={getText('ctaText')}
                />
            </Flex>
            <CarouselComponent
                marginTop={[5, null, 6]}
                marginBottom={[4, null, 6]}
                titleMarginBottom={[4, null, 5]}
                podId={CONSTRUCTOR_PODS.CREATOR_STOREFRONT}
                grouping={GROUPING.CREATOR_STOREFRONT}
            />
        </Container>
    );
}

export default wrapFunctionalComponent(ProfileError, 'ProfileError');
